import axios from 'axios'
import {environmentConfig} from "../config/environmentConfig";

export default class ScorePredictorService {

    static async getPlayerRoundPredictions(msisdn, roundId) {
        try {
            const response = await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/get-player-round-predictions`,
                data: {
                    msisdn: msisdn,
                    roundId: roundId,
                }
            });
            return response.data;
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message

            };
            console.log(error)
        }
    }

    static async getLeagues(sportId, productId) {
        try {
            const response = await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/get-leagues`,
                data: {
                    sportId: sportId,
                    productId: productId
                }
            });
            return response.data;
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message
            };
            console.log(error)
        }
    }

    static async getLeaderBoard(msisdn, roundId) {
        try {
            const response = await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/get-leaderboard`,
                data: {
                    msisdn: msisdn,
                    roundId: roundId,
                }
            });
            return response.data;
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message
            };
            console.log(error)
        }
    }

    static async trackLogin(msisdn) {
        const response = await axios({
            url: `${environmentConfig.upstreamIntegrationHost}/track-login`,
            headers: {device: 'mobi'},
            method: 'post',
            data: {
                msisdn,
                revenuePartnerId: 1,
                isFantasy : 0,
                isScorePredictor : 1,
                isWeb : 1
            }
        });
        console.log(response.data);
        return response
    }

    static async headerEnrichedLogin(encryptedMsisdn) {
        const response = await axios({
            method: 'post',
            url: `${environmentConfig.upstreamIntegrationHost}/user-authentication/encrypted-msisdn-login`,
            data: {
                encryptedMsisdn,
            }
        });

        return response.data.token;
    }

    static async getUserMsisdn(token) {
        const user = await axios({
            method: 'post',
            url: `${environmentConfig.upstreamIntegrationHost}/user-authentication/get-msisdn-from-token`,
            data: {
                token: token
            }
        });
        return user.data.recordset[0].Msisdn;
    }

    static async getUserData(msisdn) {
        const user = await axios({
            method: 'get',
            url: `${environmentConfig.upstreamIntegrationHost}/user?msisdn=${msisdn}`
        });
        return user.data;
    }

    static async getUserToken() {
        const autoLoginResponse = await axios({
            method: 'get',
            withCredentials: true,
            headers: {device: 'mobi'},
            url: `${environmentConfig.upstreamIntegrationHost}/user-authentication/session-login`
        });
        return autoLoginResponse.data.token;
    }

    static async getLandingPageData(msisdn, username) {
        try {
            return await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/player-landing-page`,
                data: {
                    msisdn: msisdn,
                    username: username
                }
            })
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message

            };
            console.log(error)
        }
    }

    static async getPlayerWinnings(msisdn) {
        try {
            const response = await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/get-players-winnings`,
                data: {
                    msisdn: msisdn,
                }
            });
            return response.data;
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message
            };
            console.log(error)
        }
    }

    static async getRoundFixtures(roundId, msisdn) {
        try {
            const response = await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/round-fixtures`,
                data: {
                    roundId: roundId,
                    msisdn: msisdn
                }
            });
            return response.data;
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message

            };
            console.log(error)
        }
    }

    static async enterSoccerRoundPredictions(fixture, msisdn) {
        try {
            return await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/soccer/enter-predictions`,
                data: {
                    msisdn: msisdn,
                    roundId: fixture.roundId,
                    soccerFixtureId: fixture.soccerFixtureId,
                    eventTypeId: fixture.eventTypeId,
                    team1Id: fixture.team1Id,
                    team1Score: fixture.team1Score,
                    team2Id: fixture.team2Id,
                    team2Score: fixture.team2Score
                }
            })
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message

            };
            console.log(error)
        }
    }

    static async enterCricketRoundPredictions(fixture) {
        try {
            return await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/cricket/enter-predictions`,
                data: {
                    msisdn: fixture.msisdn,
                    roundId: fixture.roundId,
                    cricketFixtureId: fixture.cricketFixtureId,
                    eventTypeId: fixture.eventTypeId,
                    teamId: fixture.teamId,
                    battingWinMargin: fixture.battingWinMargin,
                    bowlingWinMargin: fixture.bowlingWinMargin,
                }
            })
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message

            };
            console.log(error)
        }
    }

    static async enterOlympicsRoundPredictions(fixture, msisdn) {
        try {
            return await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/olympics/enter-predictions`,
                data: {
                    msisdn: msisdn,
                    roundId: fixture.roundId,
                    eventId: fixture.eventId,
                    gold: fixture.gold,
                    silver: fixture.silver,
                    bronze: fixture.bronze,
                }
            })
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message

            };
            console.log(error)
        }
    }

    static async getRoundPredictions(msisdn, roundId) {
        try {
            const response = await axios({
                method: 'post',
                url: `${environmentConfig.scorePredictorServiceUrl}/round-predictions`,
                data: {
                    msisdn: msisdn,
                    roundId: roundId,
                }
            });
            return response.data;
        } catch (e) {
            const error = {
                name: e.name,
                description: e.message

            };
            console.log(error)
        }
    }
}
